module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.file) ? _c('v-dialog', {
    attrs: {
      "width": "50%",
      "max-width": "700px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Store Listing for " + _vm._s(_vm.item.name))])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "center-align",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    staticClass: "responsive-img elevation-5",
    attrs: {
      "src": _vm.item.file.thumbs.small
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-form', {
    attrs: {
      "rel": "storeitem"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show In Store"
    },
    model: {
      value: (_vm.storeItem.enabled),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "enabled", $$v)
      },
      expression: "storeItem.enabled"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.storeItem.title),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "title", $$v)
      },
      expression: "storeItem.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Subtitle / Client Item # / Document Name"
    },
    model: {
      value: (_vm.storeItem.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "subtitle", $$v)
      },
      expression: "storeItem.subtitle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Public Sell Price",
      "prefix": "$"
    },
    model: {
      value: (_vm.storeItem.retail),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "retail", $$v)
      },
      expression: "storeItem.retail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Published Date"
    },
    model: {
      value: (_vm.storeItem.published_date),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "published_date", $$v)
      },
      expression: "storeItem.published_date"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Edition"
    },
    model: {
      value: (_vm.storeItem.edition),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "edition", $$v)
      },
      expression: "storeItem.edition"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description"
    },
    model: {
      value: (_vm.storeItem.description),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "description", $$v)
      },
      expression: "storeItem.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Excerpt"
    },
    model: {
      value: (_vm.storeItem.excerpt),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "excerpt", $$v)
      },
      expression: "storeItem.excerpt"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Quotes"
    },
    model: {
      value: (_vm.storeItem.quotes),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "quotes", $$v)
      },
      expression: "storeItem.quotes"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Reviews"
    },
    model: {
      value: (_vm.storeItem.reviews),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "reviews", $$v)
      },
      expression: "storeItem.reviews"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "About"
    },
    model: {
      value: (_vm.storeItem.about),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "about", $$v)
      },
      expression: "storeItem.about"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Contact"
    },
    model: {
      value: (_vm.storeItem.contact),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "contact", $$v)
      },
      expression: "storeItem.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Website"
    },
    model: {
      value: (_vm.storeItem.website),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "website", $$v)
      },
      expression: "storeItem.website"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Returns"
    },
    model: {
      value: (_vm.storeItem.returns),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "returns", $$v)
      },
      expression: "storeItem.returns"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "ISBN"
    },
    model: {
      value: (_vm.storeItem.isbn),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "isbn", $$v)
      },
      expression: "storeItem.isbn"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "EAN-13"
    },
    model: {
      value: (_vm.storeItem.ean_13),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "ean_13", $$v)
      },
      expression: "storeItem.ean_13"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "UPC"
    },
    model: {
      value: (_vm.storeItem.upc),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "upc", $$v)
      },
      expression: "storeItem.upc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Client Item #"
    },
    model: {
      value: (_vm.storeItem.client_item_number),
      callback: function($$v) {
        _vm.$set(_vm.storeItem, "client_item_number", $$v)
      },
      expression: "storeItem.client_item_number"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendToStore(_vm.item.id)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1439a252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/add-to-store.vue
// module id = 772
// module chunks = 1